import { confirmEmailCode } from '@client/new/api/auth.api';
import { useUser } from '@client/new/hooks/use-user';
import { navigate, PATHS } from '@client/routes';
import { useCallback, useState } from 'react';
import { toast } from 'react-hot-toast';
import { useLoginStore } from '../../../../stores/login.store';
import { CodeConfirmation } from '../../code-confirmation';
import { trackLogin } from '@services/tracking';
import { F0 } from '@client/new/helpers/types';

export const CreatorConfirmationCodePage = () => {
  const [loading, setLoading] = useState(false);
  const { email } = useLoginStore();
  const { login } = useUser();

  const verifyCode = useCallback(
    async (code: string, onError: F0) => {
      setLoading(true);
      confirmEmailCode(email, code)
        .then(({ user }) => {
          if (!user) {
            throw new Error('Invalid code');
          }
          login(user);
          setLoading(false);
          console.log('login', user);
          trackLogin({
            uid: user.id,
            'First Name': user.firstName,
            'Last Name': user.lastName,
            Email: user.email,
          });
          setTimeout(() => {
            navigate(PATHS.HOME);
          }, 250);
        })
        .catch((err) => {
          console.log('err', err);
          toast.error('Invalid code');
          setLoading(false);
          onError();
        });
    },
    [email, login],
  );

  if (!email) {
    return navigate(PATHS.LOGIN);
  }

  return (
    <CodeConfirmation
      email={email}
      verifyCode={verifyCode}
      isVerifying={loading}
    />
  );
};
